/**
 * The galactic plane's orientation, shared by `GalaxyBackground` (the baked
 * cube map) and `Starfield` (the foreground points): both need the same
 * plane so the crisp foreground stars and the baked band behind them agree
 * on where the Milky Way actually is.
 */

/** Tilted well away from the ecliptic so the band crosses the sky at an angle rather than lying along the planets' orbits. */
export const GALACTIC_NORMAL: readonly [number, number, number] = [0.32, 0.86, -0.4];

/** Direction toward the galactic centre/bulge, used only by the baked background (brightening and reddening the disc there). */
export const GALACTIC_CENTRE: readonly [number, number, number] = [-0.78, 0.24, 0.58];
